import { useCallback, useMemo } from 'react';
import { useHistoryInfiniteQuery } from '../core/queries/history';

export function useHistory({ type = 'all', period = 'all', enabled = true } = {}) {
  const query = useHistoryInfiniteQuery({ type, period, enabled });
  const items = useMemo(
    () => (query.data?.pages || []).flatMap((page) => page?.items || []),
    [query.data]
  );

  const loadMore = useCallback(() => {
    if (!query.hasNextPage || query.isFetchingNextPage) return;
    query.fetchNextPage();
  }, [query]);

  return {
    items,
    isLoading: query.isLoading,
    isLoadingMore: query.isFetchingNextPage,
    hasMore: Boolean(query.hasNextPage),
    error: query.error ?? null,
    loadMore,
    refetch: query.refetch,
  };
}

export default useHistory;
